import React from 'react';
import { Link } from 'react-router-dom';
import { UserCheck, ArrowLeft } from 'lucide-react';
import logoImg from '../../_asset/logo/logo.svg';

const OFFICER_GRADIENT = 'linear-gradient(150deg, #1b6b50 0%, #1f7a5c 45%, #3fa984 100%)';

const MobileAppPrompt = () => {
  return (
    <div className="flex min-h-screen flex-col bg-white font-inter">
      <header className="flex items-center justify-between px-6 py-5 sm:px-10">
        <div className="logo flex items-center gap-2">
          <img src={logoImg} alt="logo" className="w-auto h-8 md:h-10 object-contain" />
          <span className="text-xl sm:text-2xl font-bold text-[#404880]">Officer.app</span>
        </div>
        <Link
          to="/home"
          className="inline-flex items-center gap-1 rounded-lg border border-gray-200 bg-white px-3 py-1.5 text-xs font-medium text-gray-600 transition-colors hover:bg-gray-50 hover:text-gray-900 no-underline"
        >
          <ArrowLeft size={13} />
          Back to portals
        </Link>
      </header>

      <div className="flex flex-1 flex-col items-center justify-center gap-4 px-6 text-center">
        <div
          className="flex h-14 w-14 items-center justify-center rounded-2xl text-white"
          style={{ background: OFFICER_GRADIENT }}
        >
          <UserCheck size={26} />
        </div>
        <h1 className="text-lg font-semibold text-gray-900">Officers work from the mobile app</h1>
        <p className="max-w-sm text-sm text-gray-400">
          Download the Officer.app mobile app to view and take up shifts as an officer.
        </p>
      </div>
    </div>
  );
};

export default MobileAppPrompt;
